import type { IGlobalState } from "./reducer/types";

const channelName = (host: IGlobalState["host"], userId: number) => `amtdl-work-company:${host}:${userId}`;

export function listenForWorkCompanyChange(host: IGlobalState["host"], userId: number, version: string, onChange: () => void) {
  if (typeof BroadcastChannel === "undefined") return () => {};
  let channel: BroadcastChannel;
  try {
    channel = new BroadcastChannel(channelName(host, userId));
  } catch {
    return () => {};
  }
  channel.onmessage = ({ data }: MessageEvent<unknown>) => {
    if (!data || typeof data !== "object" || !("previousVersion" in data) || !("version" in data)) return;
    if (typeof data.previousVersion !== "string" || typeof data.version !== "string" || !data.version.trim()) return;
    if (data.version !== data.previousVersion && version === data.previousVersion) {
      onChange();
    }
  };
  return () => channel.close();
}

export function notifyWorkCompanyChange(host: IGlobalState["host"], userId: number, previousVersion: string, version: string) {
  if (typeof BroadcastChannel === "undefined") return;
  // Only request a reload; user data and the version still come from the server.
  let channel: BroadcastChannel | undefined;
  try {
    channel = new BroadcastChannel(channelName(host, userId));
    channel.postMessage({ previousVersion, version });
  } catch {
    // Server version checks remain authoritative if browser messaging is unavailable.
  } finally {
    channel?.close();
  }
}
